import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { SearchIndex } from '@app/shared/components/catalog/services/instantsearch.service.ts';
import { IndexSortBy } from '@app/shared/components/catalog/custom-widgets/custom-sort-by-selector/index-sort-by';
import { LocaleService } from '@app/core/i18n';

interface Refinement {
  [facet: string]: string[];
}
interface EditorPicksElem {
  name: string;
  resolvedName: string;
  algoliaDataAttr: string;
}

interface EditorRefinement {
  label: string;
  staticField: boolean;
}

interface SortByValue {
  name: SearchIndex;
  index: IndexSortBy;
}

@Injectable()
export class RefinementsService {
  private refinements = new Subject<Refinement>();
  private editorRefinements = new Subject<EditorRefinement>();

  // Index should come from indexSortBy.Default but for a reason I don't understand, if I do this it'll break some tests.
  private sortByValue = new BehaviorSubject<SortByValue>({ name: SearchIndex.Default, index: IndexSortBy.Default });

  public isStockPage = false;
  public isStock = false;

  public editorPicksIds: EditorPicksElem[] = [
    {
      name: 'Vintage',
      resolvedName: 'vintage',
      algoliaDataAttr: 'Vintage'
    },
    {
      name: 'We love',
      resolvedName: 'welove',
      algoliaDataAttr: 'We love'
    },
    {
      resolvedName: '1',
      name: 'Ready to ship',
      algoliaDataAttr: 'Stock'
    }
  ];

  constructor(private localeService: LocaleService) {
    const index = IndexSortBy.Default;
    let name = SearchIndex.Default;
    switch (this.localeService.getCountry()) {
      case 'US':
        name = SearchIndex.DefaultUs;
        break;
    }
    this.sortByValue.next({ index, name });
  }

  setRefinements(data: Refinement) {
    this.refinements.next(data);
  }

  getRefinements(): Observable<Refinement> {
    return this.refinements.asObservable();
  }

  setEditorRefinements(data: EditorRefinement) {
    this.editorRefinements.next(data);
  }

  getEditorRefinements(): Observable<EditorRefinement> {
    return this.editorRefinements.asObservable();
  }

  clearRefinements(): void {
    this.editorRefinements.next();
    this.refinements.next();
    this.isStock = false;
  }

  setSortByValue(value: SortByValue) {
    this.sortByValue.next(value);
  }

  getSortByValue(): Observable<SortByValue> {
    return this.sortByValue.asObservable();
  }
}
